import { Button, Flex, Select } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { NumOfBsd, NumOfGroup, NumOfSmsTel, PAGE_SIZE } from "CommonData"; // src/CommonData.js
import { getBsdList } from "pages/Admin/Device/apis/adminDeviceApis";
import { currentBsdState } from "pages/Login/atom/currentBsdState";
import { userGroupState } from "pages/Login/atom/userGroupState";
import { userLevelState } from "pages/Login/atom/userLevelState";
import { userState } from "pages/Login/atom/userState";
import { currentBsdListState, smsReceiveTelNoState } from "pages/atom/globalState";
import { useRecoilState, useRecoilValue } from "recoil";
import { getSmsReceiveList } from "../apis/receiveSettingApis";

function ReceiveSettingTable() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(PAGE_SIZE);
  const [noOfGroup] = useState(NumOfGroup);

  const [user, setUser] = useRecoilState(userState);
  const userLevel = useRecoilValue(userLevelState);
  const userGroup = useRecoilValue(userGroupState);

  const [receiveList, setReceiveList] = useState([]);
  const [receiveTelNoState, setReceiveTelNoState] =
    useRecoilState(smsReceiveTelNoState);
  const [bsdState, setBsdState] = useRecoilState(currentBsdState);
  const [bsdListState, setBsdListState] = useRecoilState(currentBsdListState);
  const location = useLocation();
  // const [isLoading, setIsLoading] = useState(true);
  const [isNumOfSmsTel, setIsNumOfSmsTel] = useState(false);

  useEffect(() => {
    console.log("[RST 초기] userGroup:", userGroup);
    console.log("[RST 초기] bsdState:", bsdState);
    console.log("[RST 초기] receiveList:", receiveList);
  }, []);

  useEffect(() => {
    console.log("[TBL 42] location.state: ", location.state);
    if (location.state) {
      if (location.state.bsdState) {
        setBsdState(location.state.bsdState);
        console.log("[TBL 45] location.state.bsdState:", bsdState);
      }

      if (location.state.bsdListState) {
        setBsdListState(location.state.bsdListState);
      }
    }
  }, [location.state, setBsdState, setBsdListState]);

  useEffect(() => {
    // setIsLoading(true);
    if (userGroup) {
      getBsdList(NumOfBsd, page, userGroup).then((resList) => {
        const filteredList = resList.filter((item) => item.group_id === userGroup);
        const formattedBsdList = [
          // { value: 'ALL', label: '전체' },
          ...filteredList.map((item) => ({
            value: item.bsd_id,
            label: item.bsd_nm,
          }))
        ];
        setBsdListState(formattedBsdList);
        console.log("[TBL 74] formattedBsdList: ", formattedBsdList);
        // setBsdState('ALL');
        // setIsLoading(false);
      });
    }
    if (bsdState !== '') {
      console.log("[TBL 80] bsdState: ", bsdState);
        // setIsLoading(false);
    }
  }, [setBsdListState]);

  useEffect(() => {
    console.log("[TBL 84] bsdState:", bsdState);
    // if (!isLoading) {
      // if(bsdState === 'ALL' ? '' : bsdState);
      getSmsReceiveList(bsdState, pageSize, page).then((resList) => {
        if (Array.isArray(resList)) {
          setReceiveList(resList);
          console.log("[TBL 90] resList:", resList);
          console.log("[TBL 91] bsdState:", bsdState);
          console.log("[TBL 92] receiveList:", receiveList);
          if (resList.length >= NumOfSmsTel)
            setIsNumOfSmsTel(true);
        }
      });
    // }
  // }, [bsdState, page, isLoading]);
  }, [bsdState, page]);


  const columns = useMemo(() => [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      accessor: "user_name",
      title: "SMS 수신자",
    },
    {
      accessor: "sms_telno",
      title: "SMS 수신 번호",
      cellsStyle: {
        color: "blue",
        textDecoration: "underline",
      },
      onClick: function (e) {
        setReceiveTelNoState(e.record);
        navigate(`/sms/receive/${e.record.sms_telno}`, { 
          state: { 
            sms_telno: e.record.sms_telno,
            user_name: e.record.user_name,
            sms_yn: e.record.sms_yn
          } 
        });
      },
    },
    {
      accessor: "sms_yn",
      title: "SMS 발송 여부",
    },
  ], [setBsdListState, bsdState, setBsdState]);


  const SearchBar = () => {

    return (
      <Flex gap={15} mb={10} align="center">
        <Select 
          placeholder="분사 장치 선택" 
          data={bsdListState ?? []} 
          value={bsdState || null}  // null을 사용하여 undefined 방지
          // defaultValue="ALL"
          onChange={(newValue) => {
            setBsdState(newValue);
            console.log("[TBL:SearchBar] bsdState: ", newValue);
            setPage(1);
          }} 
        />
        {userLevel < 3 && (  // userLevel이 2 미만일 때만 버튼을 렌더링
        <Button 
          onClick={() => {
            if (isNumOfSmsTel) {
              alert("더이상 추가할 수 없습니다");
            } else {
              navigate("/sms/receive/add", { state: { bsdState, bsdListState } });
            }
          }}
        >
          등록
        </Button>
      )}
      </Flex>
    );
  };


  return (
    <SRD_DataTable
      searchBar={<SearchBar />}
      data={Array.isArray(receiveList) ? receiveList.map((item, index) => ({
        ...item,
        key: item.sms_telno || index // 고유한 key 추가
      })) : []}
      columns={columns}
      page={page}
      setPage={setPage}
    />
  );
}

export default ReceiveSettingTable;
